function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  className: "base",
  width: 14,
  height: 12,
  x: 2,
  y: 2,
  fill: "#DDD",
  fillRule: "nonzero"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M9.93699126,8.5 C9.71496986,9.36261361 8.93191971,10 8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C8.93191971,6 9.71496986,6.63738639 9.93699126,7.5 L16,7.5 L16,8.5 L9.93699126,8.5 Z M2.5,13.5 L16,13.5 L16,14.5 L1.5,14.5 L1.5,1.5 L16,1.5 L16,2.5 L2.5,2.5 L2.5,13.5 Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/caps-square.1fef1cbb.svg";
export { SvgComponent as ReactComponent };